import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './BonusListScreen';
import BonusList from './BonusListScreen';
import { StoreState } from 'src/store/reducers';
import { getBonuses } from '../../../../../../../../store/actions/bonus-actions';
import { QueryParams } from '../../../../../../../../types/grid';

function mapStateToProps(state: StoreState): StateProps {
    return {
        data: state.bonuses.data,
        inProgress: state.bonuses.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getBonuses(params)),
    };
}

const BonusListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(BonusList);

export default BonusListScreen;
